import classNames from 'classnames';
import React, { FC, ReactNode } from 'react';
import styles from './index.module.scss';

export const Title: FC<{
  title: string | ReactNode,
  style?: React.CSSProperties,
  extra?: ReactNode,
  showIcon?: boolean
}> = (props) => {
  const { showIcon = true } = props;
  return (
    <div className={styles.title} style={props.style}>
      {showIcon && <div className={styles.line}/>}
      <div className={styles.text}>
        {props.title}
      </div>
      <div className={styles.extra}>
        {props.extra}
      </div>
    </div>
  );
};

export const ListTitle = (props: {title: string, className?: string}) => {
  const { title, className } = props;
  return <div className={classNames(styles.listTitle, className)}>
        {title}
      </div>;
};
